document.addEventListener('DOMContentLoaded', function () {
    const isDevelopment = process.env.NODE_ENV === 'development';

    // Функция для получения значения куки
    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    const cHash = getCookie('cHash');
    const currentUrl = window.location.href;

    // Отправка уведомления о посещении страницы
    fetch('/notify', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        body: JSON.stringify({ action: 'page_visit', page: window.location.pathname, cHash: cHash, url: currentUrl })
    })
        .then(response => response.text()) // Изменено на text() для диагностики
        .then(data => {
            if (isDevelopment) {
                console.log('Server response:', data); // Логгируем ответ сервера
            }
            try {
                const jsonData = JSON.parse(data);
                if (isDevelopment) {
                    console.log('Page visit recorded:', jsonData);
                }
            } catch (e) {
                console.warn('Warning: Error parsing JSON:', e);
            }
        })
        .catch((error) => {
            console.error('Error:', error);
        });

    // Обработка нажатий кнопок
    const buttons = document.querySelectorAll('button');

    buttons.forEach(button => {
        button.addEventListener('click', function () {
            const action = this.getAttribute('data-action');
            const dataId = this.getAttribute('data-id');

            fetch('/notify', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify({ action: action, cHash: cHash, dataId: dataId, url: currentUrl, page: window.location.pathname })
            })
                .then(response => response.text()) // Изменено на text() для диагностики
                .then(data => {
                    if (isDevelopment) {
                        console.log('Server response:', data); // Логгируем ответ сервера
                    }
                    try {
                        const jsonData = JSON.parse(data);
                        if (isDevelopment) {
                            console.log('Button click recorded:', jsonData);
                        }
                    } catch (e) {
                        console.warn('Warning: Error parsing JSON:', e);
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        });
    });
});
